"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.chipColors = void 0;
var chipColors = {
  LEGAL: '#64b8d9',
  BUSINESS: '#64b8d9',
  PROJECT: '#bda1e1',
  RELATIONSHIP: '#61d3f2',
  PROJECT_SHARED: '#bda1e1'
};
exports.chipColors = chipColors;
var _default = {
  chipColors: chipColors
};
exports.default = _default;
//# sourceMappingURL=utils.js.map